/**
 * The door index.html draws before any bundle has loaded. AdultDoor claims it
 * and takes its <video> or <img> element, so a poster already on screen stays
 * there and a clip somebody has already started keeps playing; whatever else
 * the app opens on drops it whole.
 */
export interface PreDoor {
  slug: string;
  /** the whole drawn door, #door-pre */
  el: HTMLElement;
  media: HTMLVideoElement | HTMLImageElement;
  /** taps on it before the app was here: one starts a clip, a second means go */
  taps: number;
  /** performance.now() when it was drawn, and of the first tap */
  drawnAt: number;
  firstTapAt: number | null;
  /** the clip has actually started moving, not only been asked to */
  moving?: boolean;
  /** the clip refused to play, which AdultDoor answers by moving on, as it does for its own */
  failed?: boolean;
  claimed?: boolean;
}

declare global {
  interface Window { __kindlingPreDoor?: PreDoor }
}

/** The drawn door, if it is this one. A different door is dropped: two doors would be worse than a blink. */
export function claimPreDoor(slug: string): PreDoor | null {
  if (typeof window === 'undefined') return null;
  const pre = window.__kindlingPreDoor;
  if (!pre) return null;
  if (pre.claimed) return pre; // StrictMode asks twice
  if (pre.slug !== slug) { dropPreDoor(); return null; }
  pre.claimed = true;
  return pre;
}

/** Take the drawn door away, unless AdultDoor has claimed it. */
export function dropPreDoor(): void {
  if (typeof window === 'undefined') return;
  const pre = window.__kindlingPreDoor;
  if (!pre || pre.claimed) return;
  pre.el.remove();
  window.__kindlingPreDoor = undefined;
}

/** After AdultDoor has moved the media into its own door: the rest of the drawn one goes. */
export function finishPreDoor(pre: PreDoor): void {
  pre.el.remove();
  if (window.__kindlingPreDoor === pre) window.__kindlingPreDoor = undefined;
}
